export default __webpack_public_path__ + "static/media/spid-idp-arubaid.31aa720a.svg";